import { Button } from '@talentmesh/ui/components/button';
import { RHFInput } from '@talentmesh/ui/components/rhf-input';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { UserPlus } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';

function CandidateInputForm() {
    const { processingState } = useInviteCandidateContext();
    const { formState } = useFormContext();

    return (
        <div className="flex flex-row items-start gap-4">
            <RHFInput
                className="basis-1/3"
                name="firstName"
                fieldDataCy="firstName"
                label={UIStrings.FirstNameWithAesterisk}
            />
            <RHFInput
                className="basis-1/3"
                name="lastName"
                fieldDataCy="lastName"
                label={UIStrings.LastNameWithAesterisk}
            />
            <RHFInput className="basis-1/3" name="email" fieldDataCy="email" label={UIStrings.ApplicantEmail} />
            <div className="mt-6.5 flex min-w-40 shrink-0 flex-col">
                <Button
                    type="submit"
                    variant="default"
                    size="default"
                    disabled={processingState === ProcessingState.Processing || formState.isSubmitting}
                    className="gap-2"
                    data-cy="submitAddApplicant"
                >
                    {formState.isSubmitting ? (
                        <Spinner className="size-5 shrink-0" />
                    ) : (
                        <UserPlus className="size-5 shrink-0" />
                    )}
                    {UIStrings.AddApplicant}
                </Button>
            </div>
        </div>
    );
}

export default CandidateInputForm;
